module.exports = __webpack_public_path__ + "static/media/lesewert-logo.88343fb1.svg";